<template>
  <layout-main-inner>
    <template slot="action">
      <el-button
        slot="action"
        type="primary"
        size="small"
        @click="createItem">新增产品</el-button>
    </template>
    <layout-card-wrap hasHeaderSlot>
      <div slot="form">
        <goods-status-select v-model="config.status" />
        <ent-remote-select
          v-model="config.vendorId"
          style="width: 200px;margin-left: 10px;" />
        <el-input
          v-model="config.title"
          clearable
          style="width: 200px;margin-left: 10px;"
          placeholder="请输入产品名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        border
        :data="list">
        <el-table-column
          label="产品名称"
          min-width="140"
          prop="goodsName"></el-table-column>
        <el-table-column
          min-width="180"
          label="所属企业"
          prop="vendorName"></el-table-column>
        <el-table-column
          label="排序值"
          width="80"
          prop="sortNumber"></el-table-column>
        <el-table-column
          label="状态"
          width="80"
          prop="status"
          :formatter="row => row.status === 1 ? '已上架' : '已下架'"></el-table-column>
        <el-table-column
          label="操作"
          width="110">
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="update(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="row.status === 1"
                  @click.native="upAndDownShelves(row, 1)">上架产品</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 2"
                  @click.native="upAndDownShelves(row, 2)">下架产品</el-dropdown-item>
                <el-dropdown-item @click.native="handleView(row)">查看详情</el-dropdown-item>
                <el-dropdown-item @click.native="deleteRow(row)">删除产品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <edit-goods-modal
      ref="edit"
      @fetch="fetchList" />
    <goods-detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import Goods from '@/service/goods'
import EditGoodsModal from './busi/edit-goods-modal.vue'
import GoodsStatusSelect from './busi/goods-status-select.vue'
import GoodsDetailDrawer from './busi/goods-detail-drawer.vue'
import EntRemoteSelect from '@/components/ent-remote-select.vue'
export default {
  name: 'GoodsList',
  components: { EditGoodsModal, GoodsStatusSelect, GoodsDetailDrawer, EntRemoteSelect },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, goodsName: '', status: null, vendorId: null }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleView(row) {
      this.$refs.detail.fetch({ ...row })
    },
    update(row) {
      const {
        exchangeGoodsId,
        vendorId,
        vendorName,
        goodsName,
        sortNumber,
        goodsSmallImage,
        goodsDetailsImage,
        certIds,
        brandName,
        originregion,
        netContent,
        shelflife,
        attributes,
        status
      } = row
      this.$refs.edit.init({
        exchangeGoodsId,
        vendorId,
        vendorName,
        goodsName,
        sortNumber,
        goodsSmallImage,
        goodsDetailsImage,
        certIds: certIds || [],
        brandName,
        originregion,
        netContent,
        shelflife,
        attributes,
        status
      })
    },
    createItem() {
      this.$refs.edit.init()
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Goods.getgoodslist({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    upAndDownShelves(row, status) {
      this.$confirm('您确定上下架该产品?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const dispatch = status === 1 ? 'downshelfgoods' : 'upshelfgoods'
          this.loading = true
          Goods[dispatch]({ exchangeGoodsId: row.exchangeGoodsId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('上下架成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    deleteRow(row) {
      this.$confirm('您确定删除该产品?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Goods.deletegoods({ exchangeGoodsId: row.exchangeGoodsId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
